import { render, staticRenderFns } from "./BrandFormProfile.vue?vue&type=template&id=ac1fb272&"
import script from "./BrandFormProfile.vue?vue&type=script&lang=js&"
export * from "./BrandFormProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports